import { GetStaticPaths, GetStaticProps } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import { useRef } from 'react';
import { useTranslate } from '~/i18n';
import { NextSeo } from 'next-seo';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import GridCards from '~/components/ticketing/grid-cards';
import BusinessValues from '~/components/ticketing/business-values';
import ContactUsForm from '~/components/ticketing/contact-us-form';
import Community from '~/components/ticketing/community';
import TopSection from '~/components/ticketing/top-section';
import Partners from '~/components/ticketing/partners';
import DigitizeBusiness from '~/components/ticketing/digitize-business';
import Booking from '~/components/ticketing/booking';
import ReadyToSell from '~/components/ticketing/ready-to-sell';
import { isJarir } from '~/utils/theme';

const Ticketing = () => {
   const { translate } = useTranslate();
   const contactUsFormRef = useRef();
   return (
      <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_CAPTCHA_KEY}>
         <div>
            <NextSeo
               title={translate({ id: 'seo:ticketing title' })}
               description={translate({ id: 'seo:ticketing description' })}
               openGraph={{
                  title: translate({ id: 'seo:ticketing title' }),
                  description: translate({ id: 'seo:ticketing description' }),
               }}
            />
            <TopSection contactUsFormRef={contactUsFormRef} />
            <DigitizeBusiness />
            {!isJarir ? (
               <>
                  <BusinessValues />
                  <Community />
                  <GridCards />
                  <Partners />
                  <Booking />
                  <ReadyToSell />
               </>
            ) : null}
            <ContactUsForm contactUsFormRef={contactUsFormRef} />
         </div>
      </GoogleReCaptchaProvider>
   );
};

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};
export default Ticketing;
